const contextData = {};

const get = (key) => contextData[key];

export const Config = {
    get,
    init: (data) => Object.assign(contextData, data),
};
